export default "__VITE_ASSET__CR0Y9PAi__"